export type PageName = "home" | "golodniiKrolik" | "mLounge" | "letItBe";

export const getMetaPage = (page: PageName) => {
  switch (page) {
    case "home":
      return (
        <>
          <meta
            name="description"
            content="Бары Перми. Голодный кролик, Let it be, M Lounge, Лаундж"
          />
          <meta
            name="keywords"
            content="bars, perm, бары, пермь, голодный кролик, караоке бар, банкетный зал, let it be, m lounge, кальянная, ресторан"
          />
          <meta name="author" content="Bars Perm" />

          {/* <!-- Google / Search Engine Tags --> */}
          <meta itemProp="name" content="Бары Перми" />
          <meta
            itemProp="description"
            content="Бары Перми. Голодный кролик, Let it be, M Lounge, Лаундж"
          />
        </>
      );
    case "mLounge":
      return (
        <>
          <meta
            name="description"
            content="Лаундж кафе в Перми с шикарным панорамным видом на город. Развлечение на любой вкус: настольные игры, сони плейстейшн, прямые спортивные трансляции, кинопроектор."
          />
          <meta
            name="keywords"
            content="bar, perm, бар, пермь, m lounge, лаундж, кальянная, ресторан, кафе"
          />
          <meta name="author" content="Bars Perm" />

          {/* <!-- Google / Search Engine Tags --> */}
          <meta itemProp="name" content="M Lounge" />
          <meta
            itemProp="description"
            content="Лаундж кафе в Перми с шикарным панорамным видом на город. Развлечение на любой вкус: настольные игры, сони плейстейшн, прямые спортивные трансляции, кинопроектор."
          />
        </>
      );
    case "golodniiKrolik":
      return (
        <>
          <meta
            name="description"
            content="Караоке в Перми, где можно почувствовать себя певцом. Праздничная атмосфера и шоу программа каждые выходные."
          />
          <meta
            name="keywords"
            content="bar, perm, бар, пермь, golodnii krolik, голодный кролик, караоке, ресторан, кафе"
          />
          <meta name="author" content="Bars Perm" />

          {/* <!-- Google / Search Engine Tags --> */}
          <meta itemProp="name" content="Голодный Кролик" />
          <meta
            itemProp="description"
            content="Караоке в Перми, где можно почувствовать себя певцом. Праздничная атмосфера и шоу программа каждые выходные."
          />
        </>
      );
    case "letItBe":
      return (
        <>
          <meta
            name="description"
            content="Танцевальный бар с панорамным видом на город, расположенный на 19 этаже."
          />
          <meta
            name="keywords"
            content="bar, perm, пермь, let it be, танцевальный бар, клуб"
          />
          <meta name="author" content="Bars Perm" />

          {/* <!-- Google / Search Engine Tags --> */}
          <meta itemProp="name" content="Банкетный зал" />
          <meta
            itemProp="description"
            content="Танцевальный бар с панорамным видом на город, расположенный на 19 этаже."
          />
        </>
      );
  }
};
